import { useTranslation } from "@opendash/i18n";
import { stringToTag } from "@opendash/ui";
import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { Message } from "../../../js/parsegenerated";
import { useHideOnPrint } from "../hooks/useHideOnPrint";

const { Text } = Typography;
export const MessagesContent = observer(
  (props: { message: Message; forceHide?: boolean; onClick?: Function }) => {
    const { message, forceHide, onClick } = props;
    const t = useTranslation();
    const { className, icon, toggleIsVisible, title, isVisible } =
      useHideOnPrint(forceHide, true);

    const handleMessageClick = () => {
      toggleIsVisible();
      if (onClick) onClick();
    };
    const hasTitle = message?.title ? true : false;
    const hasContent = message?.content ? true : false;

    return (
      <Flex
        className={className}
        onClick={handleMessageClick}
        title={title}
        style={{ cursor: "pointer", userSelect: "none" }}
        align="center"
        gap="1vw"
      >
        <Flex vertical gap={"0.25vw"}>
          {hasTitle && (
            <Text strong>
              {stringToTag(t(message.title, message?.data?.translation), "'")}
            </Text>
          )}
          {hasContent && <Text>{t(message.content)}</Text>}
        </Flex>
        {icon}
      </Flex>
    );
  }
);
